import { BaseApi } from "@/api/base";
import type { QueryParams } from "@/api/types";
import type { Response } from "@/api/client";
import type { ListResponseDto } from "@/api/dto/list-response.dto";
import type { Invoice } from "@/api/billing/dto/invoice";

export class BillingApi extends BaseApi {
  getInvoices(options: QueryParams = {}): Promise<Response<ListResponseDto<Invoice>>> {
    return this.client.get("billing/invoices", options);
  }
}
